import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-donor-status.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParDonorStatusDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parDonorStatusEntity = useAppSelector(state => state.parDonorStatus.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parDonorStatusDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parDonorStatus.detail.title">ParDonorStatus</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parDonorStatusEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metHealthInsurance.code">Code</Translate>
            </span>
          </dt>
          <dd>{parDonorStatusEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parDonorStatus.name">Name</Translate>
            </span>
          </dt>
          <dd>{parDonorStatusEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parDonorStatus.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parDonorStatusEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parDonorStatus.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parDonorStatusEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parDonorStatus.status">Status</Translate>
            </span>
          </dt>
          <dd>{parDonorStatusEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/par-donor-status" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-donor-status/${parDonorStatusEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParDonorStatusDetail;
